import { MyPortalClient } from 'myportal-vue3-api-client'

let client = null

export function createMyPortalClient() {
  return new MyPortalClient({
    baseURL: process.env.VUE_APP_MYPORTAL_API_BASE_URL,
    apiKey: process.env.VUE_APP_MYPORTAL_API_KEY,
    enableWebSocket: process.env.VUE_APP_MYPORTAL_ENABLE_WEBSOCKET === 'true',
    defaultDatabase: process.env.VUE_APP_MYPORTAL_DEFAULT_DATABASE,
  })
}

export function getMyPortalClient() {
  return client
}

export function setMyPortalClient(instance) {
  client = instance
}
